function createDictionnary(widthRanges, widthDelta) {
  function getWidthRanges() {
    return widthRanges;
  }

  function getWidthDelta() {
    return widthDelta;
  }

  function getOptimalWidth(width) {
    const foundWidth = widthRanges.find(
      (currentAllowedWidth) => width <= currentAllowedWidth + widthDelta,
    );

    return foundWidth ? foundWidth : widthRanges.slice(-1)[0];
  }

  function getTransformationRatio(previous, next) {
    return next / previous;
  }

  function getOptimalHeight(currentHeight, ratio) {
    return typeof currentHeight === 'number' && ratio !== Infinity
      ? Math.ceil(currentHeight * ratio)
      : currentHeight;
  }

  function getOptimalWidthAndHeight(width, height) {
    const finalWidth = getOptimalWidth(width);
    const ratio = getTransformationRatio(width, finalWidth);
    const finalHeight = getOptimalHeight(height, ratio);

    return { width: finalWidth, height: finalHeight };
  }

  return {
    getOptimalWidth,
    getOptimalWidthAndHeight,
    getWidthRanges,
    getWidthDelta,
  };
}

export default createDictionnary;
